import React from 'react';
import App from './components/App';

const MainApp = () => {
    return (
        <App />
    );
};

export default MainApp;